<template>
    <div>
        <component
            class="notification--sticky animated bounceInDown"
            v-for="notification in notifications"
            :is="componentNameFromClass(notification.type)"
            :notification="notification"
            :show-date="false"
            :show-link="false"
            :highlight="false"
            :key="notification.id">
        </component>
    </div>
</template>

<script>
    export default {
        name: "NotificationsAlerts",

        data: function () {
            return {
                notifications: [],
            }
        },

        created() {
            Quiz.$on('new-notification', (notification) => {
                this.notifications.unshift(notification)

                setTimeout(() => {
                    this.notifications = this.notifications.filter((item) => item.id != notification.id)
                }, 5000);
            })
        }
    }
</script>